<template>
  <div class="info">
    <div class="info-title">{{ $t('user.info.personalInfo') }}</div>
    <div class="info-user">
      <div class="avatar-box">
        <!-- 点头像查看大图（el-image 内置预览查看器） -->
        <el-image
          class="info-user-img"
          :src="avatarSrc"
          :preview-src-list="[avatarSrc]"
          fit="cover"
        ></el-image>
        <!-- 只有点右下角相机角标才选文件更换头像 -->
        <el-upload
          class="avatar-edit-uploader"
          action="#"
          :show-file-list="false"
          :http-request="handleAvatarUpload"
          accept="image/jpeg,image/png,image/gif,image/webp"
        >
          <div class="avatar-edit"><i class="el-icon-camera"></i></div>
        </el-upload>
      </div>
      <div class="info-user-box">
        <p>{{ $t('user.info.loginUser') }}{{ ruleForm.username }}</p>
        <!-- <p>{{ $t('user.info.balance') }}{{ ruleForm.username }}</p> -->
      </div>
    </div>
    <div class="info-title">{{ $t('user.info.basicInfo') }}</div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="150px"
      class="demo-ruleForm"
      size="small"
    >
      <el-form-item :label="$t('user.info.username')" prop="username">
        <el-input v-model="ruleForm.username" :placeholder="$t('user.info.placeholder.inputNickname')" disabled></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.info.nickname')" prop="nickname">
        <el-input v-model="ruleForm.nickname" :placeholder="$t('user.info.placeholder.inputNickname')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.info.email')" prop="email">
        <div class="form-box">
          <el-input v-model="ruleForm.email" :placeholder="$t('user.info.placeholder.inputEmail')" disabled></el-input>
        </div>
      </el-form-item>
      <el-form-item :label="$t('user.info.contactInfo')" prop="mobile">
        <div class="form-box">
          <el-input v-model="ruleForm.mobile" :placeholder="$t('user.info.placeholder.inputContact')" disabled></el-input>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('ruleForm')" style="width: 150px">{{ $t('user.info.confirm') }}</el-button>
      </el-form-item>
    </el-form>
    <!-- 邮箱 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('user.info.editEmail')"
      append-to-body
      :visible.sync="emailVisible"
      width="500px"
      :before-close="closeEmaiDialog"
    >
      <Email
        ref="emailModal"
        :record="record"
        v-if="emailVisible"
        @ok="editSuccess"
        append-to-body
      />
    </el-dialog>
    <!-- 手机号 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('user.info.editPhone')"
      append-to-body
      :visible.sync="phoneVisible"
      width="500px"
      :before-close="closePhoneDialog"
    >
      <Phone
        ref="formModal"
        :record="record"
        v-if="phoneVisible"
        @ok="editSuccess"
        append-to-body
      />
    </el-dialog>
  </div>
</template>

<script>
import { usersInfo, usersUpdate, uploadAvatar } from '@/api/user'
import Email from './components/email.vue';
import Phone from './components/phone.vue';
const  dataCity = require('@/common/city.json')
export default {
  components: {
    Email,
    Phone
  },
  computed: {
    // 当前展示的头像地址：有头像用头像，否则用默认占位图（点击预览也用它）
    avatarSrc() {
      return this.ruleForm.avatar ? this.ruleForm.avatar : this.url
    }
  },
  data() {
    return {
      emailVisible: false,
      phoneVisible: false,
      value: [],
      dataCity,
      url: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      ruleForm: {},
      rules: {},
    };
  },
  created(){
    this.getUsersInfo()
  },
  methods: {
    // 修改邮箱
    handleEmail(){
      this.emailVisible = true
    },
    // 关闭邮箱弹窗
    closeEmaiDialog(){
      this.emailVisible = false
    },
    // 修改手机号
    handlePhone(){
      this.phoneVisible = true
    },
    // 关闭手机号弹窗
    closePhoneDialog(){
      this.phoneVisible = false
    },
    handleChange(value) {
      this.ruleForm.province = value[0]
      this.ruleForm.city = value[1]
      this.ruleForm.district = value[2]
    },
    // 获取用户信息
    getUsersInfo(){
      usersInfo({user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code}).then(res => {
        if(res.code == 1){
          this.ruleForm = res.data.userinfo
        }
      })
    },
    // 自定义头像上传：选图后以 FormData 传 user/upload_avatar，成功后更新头像并同步 localStorage
    handleAvatarUpload({ file }){
      const userInfo1 = JSON.parse(window.localStorage.getItem("userInfo1")) || {}
      const formData = new FormData()
      formData.append('file', file)
      formData.append('user_code', userInfo1.user_code)
      uploadAvatar(formData).then(res => {
        if(res.code == 1){
          this.ruleForm.avatar = res.data.avatar
          // 同步 localStorage，让顶部导航等处头像即时更新
          userInfo1.avatar = res.data.avatar
          window.localStorage.setItem("userInfo1", JSON.stringify(userInfo1))
          this.$message.success(res.msg || '头像修改成功')
        }else{
          this.$message.error(res.msg || '上传失败')
        }
      }).catch(() => {
        this.$message.error('上传失败')
      })
    },
    // 编辑用户信息
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          usersUpdate({
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            nickname: this.ruleForm.nickname
          }).then(res => {
            if(res.code == 1){
              this.$message.success(res.msg)
              this.getUsersInfo()
            }else{
              this.$message.error(res.msg)
            }
          })
        } else {
          return false;
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
  .info{
    background: #fff;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    .demo-ruleForm{
      width: 50%;
    }
    .form-box{
      display: flex;
      .form-edit{
        margin-left: 10px;
      }
    }
  }
  /deep/.el-form-item__content{
    text-align: left;
  }
  .info-title{
    width: 100%;
    font-size: 16px;
    line-height: 32px;
    text-align: left;
    font-weight: bold;
  }
  .info-user{
    height: 60px;
    width: 100%;
    border-bottom: 3px solid #ccc;
    display: flex;
    align-items: center;
    padding-bottom: 10px;
    margin-bottom: 10px;
    .info-user-img{
      margin: 0 20px 0 10px;
      padding: 2px;
      width: 50px;
      height: 50px;
      border-radius: 50%;
      box-sizing: border-box;
      border: 1px solid #eee;
      overflow: hidden;
      vertical-align: middle;
      /* 换成 el-image 后圆角只加在外层 div 上，内层真实 <img> 未裁剪会显示成圆角方块；
         这里用 /deep/ 命中内层 img，强制圆形 + 裁剪填充，保证头像是正圆 */
      /deep/ .el-image__inner{
        width: 100%;
        height: 100%;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .avatar-box{
      position: relative;
      display: inline-block;
      font-size: 0;
      cursor: pointer;
    }
    /* 相机角标外层 el-upload：定位到头像右下角，只有点它才选文件更换（z-index 保证盖在头像预览热区之上） */
    .avatar-edit-uploader{
      position: absolute;
      right: 18px;
      bottom: 0;
      line-height: 0;
      z-index: 2;
    }
    .avatar-edit{
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #285EF6;
      color: #fff;
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      border: 2px solid #fff;
      box-sizing: border-box;
      cursor: pointer;
    }
    .info-user-box{
      flex: 1;
      p{
        font-size: 14px;
        line-height: 28px;
        text-align: left;
        margin: 0;
        padding: 0;
      }
    }
  }
</style>